import { Checkbox, Label } from '@teach/ui'

interface Props {
  id: string
  label: string
  /** Правая подпись строки — тот же формат, что у урока. */
  hint: string
  checked: boolean
  onToggle: () => void
}

/**
 * Строка курсовой картинки (баннер, маскоты) — в отличие от урока, своих
 * запросов у неё нет: и промпт, и картинка лежат в самом курсе.
 */
export const CourseTargetRow = ({ id, label, hint, checked, onToggle }: Props) => (
  <div className="flex items-center gap-3 rounded-md px-2 py-1.5">
    <Checkbox id={id} checked={checked} onCheckedChange={onToggle} />
    <Label htmlFor={id} className="flex-1 truncate">
      {label}
    </Label>
    <span className="text-xs text-muted-foreground">{hint}</span>
  </div>
)
